import React from "react";

export const SectionTitle = ({ children }) => (
  <h5 className="block font-mulish text-gold font-bold text-12-18 tracking-8 uppercase border-b border-gray-light py-6 w-full mb-20 overflow-hidden">
    {children}
  </h5>
);
